import React, { useCallback, useState } from 'react';
import { Form as AntdForm, Row, Col } from 'antd';
import Form from '../../../shared/Form';
import { useAuth } from '../../../hooks/useAuth';
import * as S from './styles';
import ChangePassword from '../../../shared/ChangePassword';
import moment from 'moment';

import SubscriptionStatus from '../../../shared/SubscriptionStatus';
import UpdateAvatar from '../../../shared/UpdateAvatar';
import ChangePasswordButton from '../../../shared/ChangePasswordButton';
import { roles } from '../../../utils/roles';
import { Filter } from '../../../utils/antd';
import BetaToggle from '../../BetaToggle';

const TeacherProfile = () => {
  const { user } = useAuth();
  const [changePassVisible, setChangePassVisible] = useState(false);

  const renderRoles = useCallback(() => {
    if (user) {
      return user.roles.map((role: string) => {
        const roleItem = roles.find((r: Filter) => r.value === role);
        return (
          <S.RoleText color={roleItem?.color} key={role}>
            {roleItem?.text || ''}
          </S.RoleText>
        );
      });
    }
    return null;
  }, [user]);

  return (
    <>
      <Row>
        <S.Body span={24}>
          <Form>
            <Row>
              <Col xxl={4} xl={4} lg={4} md={8} sm={24} xs={24}>
                <UpdateAvatar />
              </Col>
              <Col xxl={20} xl={20} lg={20} md={16} sm={24}>
                <Row style={{ padding: 20 }}>
                  <S.Line md={24} lg={8}>
                    <S.TitleInput>Name</S.TitleInput>
                    <AntdForm.Item name="name">
                      <S.SInput disabled bordered={false} defaultValue={user?.name} />
                    </AntdForm.Item>
                  </S.Line>
                  <S.Line md={24} lg={8}>
                    <S.TitleInput>Email/Username</S.TitleInput>
                    <AntdForm.Item name="email">
                      <S.SInput disabled bordered={false} defaultValue={user?.username} />
                    </AntdForm.Item>
                  </S.Line>
                  <S.Line md={24} lg={8}>
                    <S.TitleInput>Your Role</S.TitleInput>
                    <AntdForm.Item name="role">{renderRoles()}</AntdForm.Item>
                  </S.Line>
                  <S.CDivider />
                </Row>
                <Row style={{ padding: 20 }}>
                  <S.Line md={24} lg={8}>
                    <S.TitleInput>Organization</S.TitleInput>
                    <AntdForm.Item name="organization">
                      <S.SInput
                        disabled
                        bordered={false}
                        defaultValue={user?.organizationName || '-- NO ORGANIZATION --'}
                      />
                    </AntdForm.Item>
                  </S.Line>
                  <S.Line md={24} lg={8}>
                    <S.TitleInput>Enrolled Students</S.TitleInput>
                    <AntdForm.Item name="students">
                      <S.SInput disabled bordered={false} defaultValue="0 Students" />
                    </AntdForm.Item>
                  </S.Line>
                  <S.Line md={24} lg={8}>
                    <S.TitleInput>Enrollment Date</S.TitleInput>
                    <AntdForm.Item name="enrollment-date">
                      <S.SInput
                        disabled
                        bordered={false}
                        defaultValue={moment(+user?.enrollmentDate).format('MM.DD.YYYY, HH:mm A')}
                      />
                    </AntdForm.Item>
                  </S.Line>
                  <S.CDivider />
                </Row>
              </Col>
            </Row>
            <Row style={{ padding: 20 }}>
              <Col xxl={4} xl={4} lg={4} md={8} sm={24}>
                <S.TitleInput>Password</S.TitleInput>
                <Row>
                  <Col span={18}>
                    <AntdForm.Item name="password">
                      <S.SInput password disabled bordered={false} defaultValue="password" />
                    </AntdForm.Item>
                  </Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    <ChangePasswordButton
                      userSource={user.source}
                      handleChangePassword={() => setChangePassVisible(true)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xxl={20} xl={20} lg={20} md={16} sm={24}>
                <Row>
                  <S.Line md={24} sm={24} lg={8}>
                    <SubscriptionStatus
                      subscription={user?.subscription}
                      stripeSubscription={user?.stripeSubscription}
                    />
                  </S.Line>
                  <S.Line md={24} sm={24} lg={8}>
                    <BetaToggle />
                  </S.Line>
                  {Array.isArray(user?.userAllowedStates) && user.userAllowedStates.length > 0 && (
                    <S.Line md={24} lg={8}>
                      <S.TitleInput>Standard Preference</S.TitleInput>
                      <AntdForm.Item style={{ marginBottom: 0 }}>
                        <S.BoldSelect
                          mode="multiple"
                          disabled
                          bordered={false}
                          value={user.userAllowedStates.map((state) => state.name)}
                          options={[
                            { label: 'Texas', value: 'Texas' },
                            { label: 'Next Generation...', value: 'NGSS' },
                          ]}
                          style={{ pointerEvents: 'none' }}
                        />
                      </AntdForm.Item>

                    </S.Line>
                  )}
                </Row>
              </Col>
            </Row>
          </Form>
        </S.Body>
      </Row>
      <ChangePassword visible={changePassVisible} setVisible={setChangePassVisible} />
    </>
  );
};

export default TeacherProfile;
